<template>
  <div class="add-rank-dialog">
    <page-dialog
      :isShowFooter="true"
      :width="25"
      v-if="dialogVisible"
      @changeDialogVisible="changeDialogVisible"
      :dialogVisible="dialogVisible"
      title="添加员工"
    >
      <div class="shop-list">
        <div class="titls">
          <div>
            人员信息
          </div>
        </div>
        <el-scrollbar height="200px" v-if="unCheckUserList&&unCheckUserList.length">
          <el-checkbox-group @change="handleCheckChange" v-model="checkList">
            <template :key="item" v-for="item in unCheckUserList">
              <el-checkbox :label="item.id">
                <div class="item">
                  <div class="left">
                    <div class="name">{{ item.name }}</div>
                  </div>
                </div>
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </el-scrollbar>
        <template v-else>
          <el-empty description="暂无数据" />
        </template>
      </div>
      <template #footer>
        <div class="save-btn">
          <el-button @click="handleSaveClick" size="small" type="primary">保存</el-button>
        </div>
      </template>
    </page-dialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, watch, nextTick, computed, onUnmounted } from 'vue'
import PageDialog from '@/components/page-dialog/page-dialog.vue'
import { useStore } from 'vuex'
import { COMPANY_ID } from '@/common/constant'
import emitter from '@/utils/eventbus'
import {  setRuleBind, getRuleBindList } from '@/service/main/commission'
import { ElMessage } from 'element-plus'
import { getUnBindRuleShopList, getUnBindRuleRoleList, getOldBindShop, getOldBindRole, getRuleDetail } from '@/service/main/commission'
import {getAllRoleList} from '@/service/main/staff'
import { useRoute } from 'vue-router'
import cache from '@/utils/cache'

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    unCheckUserList: {
      type: Array,
      default:[]
    },
    ruleKind: {
      type: Number,
      default: 1
    },
    optType: {
      type: String,
      default: 'add'
    },
    chooseList:{
      type:Array,
      default:[]
    }
  },
  components: {
    PageDialog
  },
  emits: ['changeDialogVisible', 'refreshList', 'changeUserList'],
  setup(props, { emit }) {
    const route = useRoute()
    const store = useStore()
    const changeDialogVisible = (flag) => {
      emit('changeDialogVisible', flag)
    }
    const resArr = (arr1, arr2) => {
      return arr1.filter((v) => arr2.every((val) => val!= v.id));
    }
    const handleSaveClick = () => {
      let newArr= resArr(checkedList.value,props.chooseList)
      emit('changeUserList', newArr)
      changeDialogVisible(false)
      checkedList.value=[]
      checkList.value = []
    }


    const checkList = ref([])


    const getBindList = async () => {
      checkList.value = []
      let bindRes = await getRuleBindList(props.ruleId)
      bindRes.data.list.forEach(item => {
        checkList.value.push(item.relateId)
      })
    }



    const checkedList = ref([])
    const handleCheckChange = (value) => {
      let optNameArr = []
      value.forEach(ele => {
        let item = props.unCheckUserList.find(elem => elem.id == ele)
        if (item != undefined) {
          optNameArr.push(item)
        }
      })
      checkedList.value=optNameArr
    }

    const initPage = ()=>{
      checkList.value = props.chooseList
    }
    initPage()

    return {
      handleSaveClick,
      changeDialogVisible,
      checkList,
      handleCheckChange,
      checkedList
    }

  }
})
</script>

<style scoped lang="less">
.add-rank-dialog {
  font-size: 12px;

  &:deep(.el-scrollbar__view) {
    font-size: 12px;
  }

  &:deep(.el-checkbox__label) {
    font-size: 12px;
  }

  .save {
    &:deep(.el-button) {
      width: 100%;
    }
  }

  &:deep(.is-horizontal) {
    display: none !important;
  }

  &:deep(.el-dialog) {
    min-width: 350px;

    .el-dialog__body {
      padding-bottom: 10px !important;
    }
  }

  &:deep(.el-dialog__body) {
    position: relative;
    top: -15px;
  }

  .search {
    margin-bottom: 14px;
  }

  &:deep(.el-select) {
    width: 100%;
  }

  &:deep(.el-scrollbar) {
    padding: 0 10px;
  }

  .pagination {
    margin-top: 10px;
    text-align: right;
  }

  .shop-list {
    .titls {
      padding: 0 10px;
      display: flex;
      margin-bottom: 20px;
      background-color: rgb(239, 239, 239);
      font-size: 12px;

      div {
        flex: 1;
        line-height: 40px;
      }
    }

    &:deep(.el-checkbox) {
      display: flex;
      align-items: center;
      width: 100% !important;

      .el-checkbox__label {
        display: inline-block;
        width: 100%;

        .item {
          width: 97%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .right {
            position: relative;
            left: -8px;
          }

          .left,
          .right,
          .center {
            flex: 1;
          }

          .left {
            display: flex;
          }
        }
      }
    }
  }
}
</style>
